const lbaRemarksEditor = angular.module('app.lbaRemarksEditor', []);

lbaRemarksEditor.controller('lbaRemarksEditorCtrl', require('./lbaRemarksEditorCtrl'));
lbaRemarksEditor.directive('lbaRemarksEditor', require('./lbaRemarksEditorDir'));

export default lbaRemarksEditor;



// WEBPACK FOOTER //
// ./src/components/lbaRemarksEditor/index.js